export const cardLoyaltyProgramExternal = {
    targetClientId: 'ebcstore',
};
